var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoChatSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.497 24.003c-.186 0-.355-.102-.442-.266l-4.428-8.364-8.364002-4.428c-.1689995-.089-.2729995-.27-.26599951-.461.007-.19.12499951-.363.29999951-.439l23.000002-9.9999962c.012-.005.026-.01.039-.013.003-.001.006-.002.009-.002.044-.014.087-.02200002.13-.02300002.001 0 .043.001.051.001.043.00300002.085.01100002.125.02400002.019.006.033.011.048.018.062.028.11.0610002.151.1020002.041.04.074.089.1.148.004.009.015.038.018.048.014.042.022.084.024.126.001.013.002.03.002.048-.002.048-.01.092-.024.133.001.002 0 .005 0 .008-.004.014-.009.029-.014.042l-9.999 22.997996c-.076.175-.249.293-.439.3-.005 0-.017 0-.021 0zm-.044-1.652 8.536-19.632-12.377 12.377zm-4.548-7.962 12.377-12.377-19.632 8.536z",
    fill: "#17a680"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChatSend);
export default __webpack_public_path__ + "static/media/ico_chat_send.55bd33f691268f0af739ffee55f8aa0a.svg";
export { ForwardRef as ReactComponent };